export { DefaultFooter } from './default-footer.component';
